import React from "react";
import { HomeSection } from "./HomeSection";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { GameCatalog } from "../games/GameCatalog";

export function GamesSection() {
  return (
    <HomeSection
      id="games"
      title="Games"
      description="Quick puzzles, arcade classics, and multiplayer strategy. Find your next game."
    >
      <GameCatalog limit={6} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button component={Link} to="/games" variant="outlined" size="large">
          View all games
        </Button>
      </Box>
    </HomeSection>
  );
}
